<p>
  service-select works!
</p>
